var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),_c('Observer',{attrs:{"options":_vm.observerOptions},on:{"intersect":_vm.handleIntersect}}),_c('div',{staticClass:"text-center"},[(_vm.isLoaderDisplayed)?_c('LoadingProgress',{staticClass:"mt-2 mb-2",attrs:{"size":_vm.loaderSize}}):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }